/**
 * Main JavaScript entry point
 *
 * @package WPCore
 */

// Import modules
import { initNavigation } from './modules/navigation.js';
import { initAccessibility } from './modules/accessibility.js';
import { initLazyLoad } from './modules/lazy-load.js';
import { initVerifyForm } from './modules/verify-form.js';
import { initPasswordValidation } from './modules/password-validation.js';
import { initConfirmPasswordValidation } from './modules/confirm-password-validation.js';
import { initTermsValidation } from './modules/terms-validation.js';
import { initInputSpinner } from './modules/input-spinner.js';
import { initFAQ } from './modules/faq-button.js';
import { initFormatValue } from './modules/card-form.js';
import { calendar } from './calendar/index.js';
import { initSlider } from './modules/wpcore-slider.js';
import { initPlayVideo } from './modules/play-video.js';
import { initTabs } from './modules/switch-tabs.js';
import { initSeledted } from './modules/subscription-profile.js';
import { actions } from './actions/index.js';
import { initDropdown } from './modules/dropdown.js';
import { initShowMore } from './modules/showmore.js';
import { initLangSwitcher } from './modules/lang-switcher.js';
import { initMenuResponsive } from './modules/menu-sidebar-responseive.js';
import { initPopup } from './modules/popup.js';
import { initDropdownPopupCancel } from './modules/dropdown-selected.js';
import { initCountdownCanvas } from './modules/countdown-canvas.js';
import { initVideoPlayer } from './actions/play-video.js';
import { initCategoryFilter } from './modules/category-filter.js';
import { initWeightChart } from './modules/weight-chart.js';
import { initAssessmentQuestion } from './modules/assessment-question.js';
import { initLoadMoreNews } from './modules/load-more-news.js';
import { initPaymentHistoryPagination } from './modules/payment-history-pagination.js';
import { initSwiper } from './modules/swiper.js';
import { initCopyButtons } from './modules/copy-button.js';
import { initTogglePassword } from './modules/toggle-password.js';
import { coach } from './coach/index.js';
import { stages } from './stage/index.js';
import { initCollapseItem } from './modules/collapse-item.js';
import { initMoodChart } from './modules/mood-chart.js';
import { profile } from './profile/index.js';
import { initSliders } from './sliders/index.js';
import { initOnboarding } from './onboarding/index.js';
import { initAlert } from './modules/alert/index.js';
import { initRatingSlider } from './modules/progress-input.js';
import { initPaymentHistory } from './payment-history/index.js';
import { initVideoDuration } from './modules/video-duration.js';
import { initAvailabilitySettings } from './modules/availability/index.js';
import { initTextareaAutoResize } from './modules/textarea.js';
import { initPayment } from './payment/index.js';
import { initSendMessage } from './modules/send-message.js';
import { initBooking } from './booking/index.js';
import { initTimezone } from './modules/timezone.js';
import { initFirebaseConfig } from './firebase/index.js';
import { initNotifications } from './notifications/index.js';
import { initStudentQuestion } from './student-question/index.js';
import { initRecipes } from './recipe/index.js';
import { initVideoCategories } from './video-category/index.js';
import { initAmbassador } from './ambassador/index.js';
import { initI18n } from './utils/i18n.js';
import { initDownloadFile } from './modules/download-file.js';
import { initVideoPoster } from './modules/video-poster.js';

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
	initI18n();
	initFirebaseConfig();
	initPopup();
	initNavigation();
	initAccessibility();
	initLazyLoad();
	initVerifyForm();
	initPasswordValidation();
	initConfirmPasswordValidation();
	initTermsValidation();
	initInputSpinner();
	initFAQ();
	initFormatValue();
	calendar();
	initSlider();
	initPlayVideo();
	initTabs();
	initSeledted();
	actions();
	initDropdown('#notifi-btn', '#notifi-dropdown');
	initShowMore('#btn-see-all', '.hidden-item');
	initLangSwitcher();
	initMenuResponsive();
	initDropdownPopupCancel();
	initCountdownCanvas();
	initVideoPlayer();
	initAssessmentQuestion();
	initWeightChart();
	initMoodChart();
	initCollapseItem();
	initCategoryFilter('.btn-filter', '.menu-detail-item');
	initSwiper();
	initCopyButtons();
	initTogglePassword();
	initLoadMoreNews();
	initPaymentHistoryPagination();
	coach();
	stages();
	profile();
	initSliders();
	initOnboarding();
	initAlert();
	initRatingSlider();
	initPaymentHistory();
	initVideoDuration();
	initAvailabilitySettings();
	initPayment();
	initSendMessage();
	initTextareaAutoResize();
	initNotifications();
	initBooking();
	initStudentQuestion();
	initTimezone();
	initAmbassador();
	initRecipes();
	initVideoCategories();
	initDownloadFile();
	initVideoPoster();
});
